const LoadingSpinner = () => (
  <p className="text-center">
    <i className="fa fa-spinner fa-spin" /> Loading…
  </p>
);

export default LoadingSpinner;
